import type { ContactInfo } from '~/base/types/contact/contact'
import type { Technician } from '~/base/types/technician/technician'

export enum AppointmentState {
  Unconfirmed = 'Unconfirmed',
  Confirmed = 'Confirmed',
  Delegated = 'Delegated',
  Cancelled = 'Cancelled',
  Rescheduled = 'Rescheduled',
  WorkOrderRejected = 'WorkOrderRejected',
  AppointmentCompleted = 'AppointmentCompleted',
  Unscheduled = 'Unscheduled'
}

export enum AppointmentUpdateAction {
  Update = 'Update',
  Confirm = 'Confirm',
  Delegate = 'Delegate',
  Reschedule = 'Reschedule'
}

export interface Timeslot {
  from: Date
  to: Date
}

export interface AvailableTimeslot {
  from: string
  to: string
}

export interface FormattedTimeslot {
  day: string
  time: string
}

export interface AlternativeContact extends ContactInfo {
  role: string
}

export interface AdditionalInfoObject {
  phone: string
  general: string
}

export interface OptIns {
  terms: boolean
  feedback: boolean
}

export interface Tenant {
  firstName: string
  lastName: string
  phone: string
  email: string
  street: string
  houseNr: string
  floor: string
  postalCode: string
  city: string
}

export interface Address {
  city: string
  floor: string
  houseNr: string
  postalCode: string
  street: string
}

export interface Video {
  description: string
  steps: string[]
  summary: string
  title: string
  videoId: string
}

export interface Appointment {
  sagaThirdAppointment?: boolean
  id: string
  activities: string // geplante Arbeiten
  additionalInfos: AdditionalInfoObject
  alternativeContact: AlternativeContact
  contactInfo: ContactInfo
  location: Address
  state: AppointmentState
  timeslot: Timeslot
  prevTimeslot: Timeslot | null
  preferredTimeslot: Timeslot | null
  workOrderId: string
  workOrderType: string
  shortUrl: string
  childShortUrl: string
  isDelegated: boolean
  video: Video | null
  technician: Technician
  optIns: OptIns
}

export interface AppointmentModuleState {
  appointment: Appointment
}
